import type { FeatureFlagCatalog } from "@cede/types";
import { useInternalFeatureFlags } from "./useInternalFeatureFlags";

/**
 * Check if a feature flag is enabled.
 * Fetches flags from internal CMS via the backend API.
 */
export const useFeatureFlagIsOn = <K extends keyof FeatureFlagCatalog>(featureKey: K): boolean => {
  const { data: internalFlags } = useInternalFeatureFlags();

  const internalValue = internalFlags?.[featureKey]?.value;
  if (typeof internalValue === "boolean") {
    return internalValue;
  }

  // Return false if flag not found (default off)
  return false;
};

/**
 * Get a feature flag value.
 * Fetches flags from internal CMS via the backend API.
 */
export const useFeatureFlagValue = <K extends keyof FeatureFlagCatalog>(
  featureKey: K,
  defaultValue: FeatureFlagCatalog[K],
): FeatureFlagCatalog[K] => {
  const { data: internalFlags } = useInternalFeatureFlags();

  const internalValue = internalFlags?.[featureKey]?.value;
  if (internalValue !== undefined) {
    return internalValue as FeatureFlagCatalog[K];
  }

  // Return default value if flag not found
  return defaultValue;
};
